(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('[data-pdp-video-gallery]').forEach((gallery) => {
    let paused = false;
    let visible = false;
    const videos = [...gallery.querySelectorAll('video')];
    const pause = () => { paused = true; };
    gallery.addEventListener('pointerenter', pause);
    gallery.addEventListener('focusin', pause);
    gallery.addEventListener('touchstart', pause, { passive: true });
    const galleryObserver = new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; }, { threshold: 0.35 });
    galleryObserver.observe(gallery);
    const videoObserver = new IntersectionObserver((entries) => entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && visible && !document.hidden) video.play().catch(() => {});
      else video.pause();
    }), { threshold: 0.6 });
    videos.forEach((video) => videoObserver.observe(video));
    window.setInterval(() => {
      if (paused || !visible || document.hidden) return;
      const next = gallery.scrollLeft + gallery.clientWidth * 0.84;
      gallery.scrollTo({ left: next >= gallery.scrollWidth - gallery.clientWidth - 2 ? 0 : next, behavior: 'smooth' });
    }, 4200);
  });
})();
